import { SortDir } from '__generated__';
import bind from 'memoize-bind';
import React, { PureComponent } from 'react';

import { SortContext, SortDirection, SortDirectionMap } from './SortContext';

interface SortProps<T = string> {
  defaultDirections?: SortDirectionMap;
  sorts: SortDirection<T>[];
  maxSorts: number;
  minSorts: number;
  onSortChange: (sorts: SortDirection<T>[]) => void;
}

export class Sort<T = string> extends PureComponent<
  React.PropsWithChildren<SortProps<T>>
> {
  static defaultProps: SortProps = {
    maxSorts: 1,
    minSorts: 1,
    sorts: [],
    onSortChange: () => undefined,
  };

  onHeaderClick(prop: T) {
    const { defaultDirections, maxSorts, minSorts, onSortChange } = this.props;
    const sorts = [...this.props.sorts];
    const sortIdx = sorts.findIndex((s) => s.prop === prop);
    const sortCount = sorts.length + 1;

    if (sortIdx === -1) {
      if (sortCount >= maxSorts) {
        sorts.splice(0, sortCount - maxSorts);
      }

      sorts.push({
        prop,
        direction:
          defaultDirections &&
          typeof prop === 'string' &&
          defaultDirections[prop]
            ? defaultDirections[prop]
            : SortDir.Asc,
      });
    } else {
      const sort = sorts[sortIdx];

      if (sort.direction === SortDir.Asc) {
        sorts[sortIdx] = {
          ...sort,
          direction: SortDir.Desc,
        };
      } else if (sortCount - 1 <= minSorts) {
        sorts[sortIdx] = {
          ...sort,
          direction: SortDir.Asc,
        };
      } else {
        sorts.splice(sortIdx, 1);
      }
    }

    onSortChange(sorts);
  }

  render() {
    const { children, sorts } = this.props;

    return (
      <SortContext.Provider
        value={{
          // @ts-ignore
          onHeaderClick: bind(this.onHeaderClick, this),
          sorts,
        }}
      >
        {children}
      </SortContext.Provider>
    );
  }
}
